/**
 * Client mirror of supabase/functions/_shared/unknownProficiency.ts — the ONE
 * assignment law for a missing category proficiency: UNKNOWN, not 0.
 *
 * The browser bundle does not import runtime values from the Edge tree, so the
 * few pieces the client matcher needs are mirrored here and held identical by
 * tests/unit/unknownProficiencyAcrossSurfaces.test.ts (same constant, same
 * answers on the same fixtures).
 *
 * UNKNOWN_PROFICIENCY_ORDERING_VALUE is an ORDERING PRIOR ONLY (product
 * sign-off, roadmap #8): never stored, never rendered as a percentage, never
 * written to CORE-E, never influenced by trade background.
 */
export const UNKNOWN_PROFICIENCY_ORDERING_VALUE = 50;

/** A stored category value, or null when there is none (never 0). */
export function knownProficiencyValue(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '' || typeof raw === 'boolean') return null;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isFinite(n) ? n : null;
}

/** Weighted mean of the KNOWN values only; null when nothing is known. */
export function knownWeightedMean(entries: ReadonlyArray<{ value: number | null; weight?: number }>): number | null {
  let sum = 0;
  let total = 0;
  for (const e of entries) {
    if (e.value === null) continue;
    const w = e.weight ?? 1;
    sum += e.value * w;
    total += w;
  }
  return total > 0 ? sum / total : null;
}

/** The value an ordering compares: the known signal, else the hidden midpoint. */
export function proficiencyOrderingValue(known: number | null | undefined): number {
  return known == null ? UNKNOWN_PROFICIENCY_ORDERING_VALUE : known;
}
